import {METER_INPUT} from 'constants/enum/meterInput'
import {METER_INPUT_TYPE} from 'constants/enum/meterInputType'
import providers from 'constants/enum/meterProvider'
import {METER_CATEGORY} from 'constants/enum/meterType'
import ZodConfig from 'constants/zodConfig'
import {z} from 'zod'

const normalizeChargeKey = (value) => (value || '').trim()

const structure = {
    name: 'structure',
    type: 'autocomplete',
    label: 'structure',
    rules: {required: true},
    // defaultValueFieldName: 'structure._id',
    sm: 4,
    xs: 12,
}
const consumer = {
    name: 'consumer',
    type: 'autocomplete',
    label: 'consumer',
    rules: {required: true},
    // defaultValueFieldName: 'consumer._id',
    sm: 4,
    xs: 12,
}
const name = {
    name: 'name',
    rules: {required: true},
    sm: 6,
    xs: 6,
}
const meterId = {
    name: 'meterId',
    rules: {required: true},
    sm: 6,
    xs: 6,
}

const category = {
    name: 'category',
    type: 'select',
    options: METER_CATEGORY,
    rules: {required: true},
    withTranslation: true,
    sm: 4,
    xs: 12,
}

const conversionRate = {
    name: 'conversionRate',
    type: 'number',
    sm: 4,
    xs: 6,
}

const rolloverValue = {
    name: 'rolloverValue',
    type: 'number',
    sm: 4,
    xs: 6,
}

const chargeKey = {
    label: 'chargeKey',
    name: 'key',
    rules: {required: true},
    sm: 6,
    xs: 12,
    inputProps: {maxLength: 100},
}

const chargeValue = {
    label: 'chargeValue',
    name: 'value',
    type: 'number',
    rules: {required: true},
    sm: 6,
    xs: 12,
}

const additionalCharges = {
    title: 'additionalCharges',
    type: 'array',
    withButtons: true,
    appendOnEmpty: false,
    arrayName: 'additionalCharges',
    items: {key: chargeKey, value: chargeValue},
}

const consumerUpdateDate = {
    name: 'consumerUpdateDate',
    type: 'datepicker',
    label: 'consumerUpdateDate',
    sm: 6,
    xs: 12,
    hidden: true,
}

const structureUpdateDate = {
    name: 'structureUpdateDate',
    type: 'datepicker',
    label: 'structureUpdateDate',
    sm: 6,
    xs: 12,
    hidden: true,
}

export const inputType = {
    name: 'inputType',
    type: 'select',
    options: METER_INPUT_TYPE,
    sm: 4,
}

const provider = {
    name: 'provider',
    type: 'select',
    options: providers.PROVIDERS,
    sm: 4,
}
// const type = {
//     name: 'type',
//     type: 'select',
//     options: METER_TYPE,
//     sm: 4,
// }

const active = {
    name: 'active',
    type: 'switch',
    sm: 4,
    xs: 12,
}
export const input = {
    name: 'input',
    type: 'select',
    options: METER_INPUT,
    sm: 4,
}
export const createMeterField = {
    active: {
        items: {
            active,
        },
    },
    createMeter: {
        title: 'createMeter',
        items: {
            structure,
            consumer,
            category,
            name,
            meterId,
            provider,
        },
    },
    settings: {
        title: 'settings',
        items: {
            conversionRate,
            rolloverValue,
        },
    },
    relationshipUpdates: {
        title: 'relationshipUpdates',
        hidden: true,
        items: {
            consumerUpdateDate,
            structureUpdateDate,
        },
    },
    additionalCharges,
}

export const createMeterFieldValidation = z.object({
    structure: ZodConfig.stringDocument(),
    consumer: ZodConfig.stringDocument().nullable().optional(),
    category: ZodConfig.enum(METER_CATEGORY),
    name: ZodConfig.string(),
    meterId: ZodConfig.string(),
    conversionRate: ZodConfig.number().optional(),
    rolloverValue: ZodConfig.number().optional(),
    inputType: ZodConfig.enum(METER_INPUT_TYPE).optional(),
    input: ZodConfig.enum(METER_INPUT).optional(),
    active: ZodConfig.boolean().optional(),
    consumerUpdateDate: ZodConfig.date().optional(),
    structureUpdateDate: ZodConfig.date().optional(),
    provider: ZodConfig.enum(providers.PROVIDERS),
    additionalCharges: ZodConfig.array(
        z.object({
            key: z
                .string({message: 'required'})
                .trim()
                .min(1, {message: 'required'})
                .max(100, {message: 'charge_key_max'}),
            value: ZodConfig.number({min: 0}),
        })
    )
        .transform((items) =>
            items?.map((item) => ({
                ...item,
                key: normalizeChargeKey(item.key),
            }))
        )
        .optional(),
})

export const meterValidationSchemaSuperRefine = (data, ctx) => {
    if (!data.consumer && data.active) {
        ctx.addIssue({
            path: ['consumer'],
            code: z.ZodIssueCode.custom,
            message: 'Required',
        })
    }

    const keys = new Set()
    data.charges?.forEach((charge, index) => {
        if (!charge?.key) return
        const normalizedKey = normalizeChargeKey(charge.key).toLowerCase()
        if (keys.has(normalizedKey)) {
            ctx.addIssue({
                path: ['charges', index, 'key'],
                code: z.ZodIssueCode.custom,
                message: 'duplicate_charge_key',
            })
        } else {
            keys.add(normalizedKey)
        }
    })
}
